<nb-card class="investment-quote-part-dialog" style="width: 900px">
  <nb-card-header class="display-6 dialog-title">{{ 'quote_part.change_quote_part_investment' | translate }}</nb-card-header>
  <nb-card-body>
    <form [formGroup]="repartitionForm">
      <!-- Name and Archive Checkbox -->
      <p class="distribution-key text-danger fw-light">{{'quote_part.distribution_key' | translate}} {{repartitionForm.controls['name'].value}}</p>

      <!-- Table for Distribution -->
      <div class="flex flex-column">
        <div class="distribution-wrapper">
          <table class="table">
            <thead class="table-secondary">
            <tr >
              <th> {{'quote_part.owner' | translate}}</th>
              <th style="width: 12%">%</th>
              <th style="width: 20%">{{'Budget' | translate}}</th>
              <th style="width: 15%">{{ 'quote_part.property_code' | translate }}</th>
              <th>{{ 'Label' | translate }} {{
                  'quote_part.property_code' |
                    translate
                }}
              </th>
            </tr>
            </thead>
            <tbody formArrayName="distribution">
              @for (item of distributionControls.controls; track item; let i = $index) {
                <tr [formGroupName]="i">
                  <td>
                    {{ getSponsorName(item) }}
                  </td>
                  <td class="text-center">
                    <input class="quote-part-percentage text-center" nbInput fullWidth
                           formControlName="percentage"
                           type="number" min="1" max="100"/>
                  </td>
                  <td>
                    {{ getPrice(item) }}
                  </td>
                  <td>
                    {{ item.get('property_code')?.value }}
                  </td>
                  <td>
                    {{ item.get('property_code_label')?.value }}
                  </td>
                </tr>
              }
            <tr>
              <td class="text-left">
                Total
              </td>
              <td class="text-right">
                <span>{{ getTotalPercentage() }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </form>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton (click)="close()" class="me-3">{{ 'Cancel' | translate }}</button>
    <button nbButton (click)="confirmOK()"
            [disabled]="!isUpdateBtnEnabled">{{ 'OK' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
<ng-template #alertDialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>{{ 'core.utils.error.validation-title' | translate }}</nb-card-header>
    <nb-card-body>{{ data.message | translate }}</nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="ref.close()">{{ 'pages.common.charts.base-chart.close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
